import { Injectable } from '@angular/core';
import { DataService } from '../../shared/services/data.service';
import { StorageService } from '../../shared/services/storage.service';
import { ResponseModel } from '../../shared/models/response-model.model';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MinizUserRegistrationService {

  constructor(public service: DataService, public storageService: StorageService) { }

  getAllMinizUserListData(data: any) {
      let url = `api/App/UserOnboarding/getAllMinizUsers`;
      return this.service.post(url, data).pipe<ResponseModel>(tap((response: any) => {
        return response;
      })
      );
    }

  insertMinizUser(data: any) {
    let url = `api/App/UserOnboarding/register/miniz`;
    return this.service.post(url, data).pipe<ResponseModel>(tap((response: any) => {
      return response;
    })
    );
  }

}
